// Is a given value equal to null?
export default function isNull(obj) {
  return obj === null;
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/isNull.js
// module id = 853
// module chunks = 115